import { Badge, Button, Tooltip } from "@jhool-io/fe-components";
import { TaskStatus } from "../../../utils/types/tasks";
import {
    removeEnumUnderscore,
    displayNameInRightFormat,
} from "../../../utils/helpers";
import UserIcon from "../../../icons/User";
import { ITask } from "../types/tasks.types";

export const getStatusTag = (status: TaskStatus) => {
    let bgColor: string;
    let textColor: string;

    switch (status) {
        case TaskStatus.NOT_STARTED:
            textColor = "#0b132b";
            bgColor = "rgba(240, 240, 229, 0.50)";
            break;

        case TaskStatus.IN_PROGRESS:
            textColor = "#634D17";
            bgColor = "rgba(247, 229, 164, 0.50)";
            break;

        case TaskStatus.COMPLETED:
            textColor = "#00563E";
            bgColor = "rgba(204, 250, 233, 0.50)";
            break;

        default:
            textColor = "#0b132b";
            bgColor = "rgba(240, 240, 229, 0.50)";
    }

    return (
        <Badge
            content={removeEnumUnderscore(status)}
            type="custom"
            textColor={textColor}
            bgColor={bgColor}
        />
    );
};

export const getTaskUsersToDisplay = (
    loggedInUserId: string,
    users?: { user_id: string; first_name: string; last_name: string }[]
) => {
    if (!users || (users && users.length === 0)) return "--";

    const loggedInUserIdIsInList = users.find(
        (user) => user.user_id === loggedInUserId
    );

    if (users.length > 0) {
        if (users.length > 1) {
            return (
                <Tooltip
                    content={`Assigned to: ${
                        loggedInUserIdIsInList ? "You," : ""
                    } ${users
                        .filter((user) => user.user_id !== loggedInUserId)
                        .map(
                            (user) =>
                                `${displayNameInRightFormat(
                                    {
                                        firstName: user.first_name,
                                        lastName: user.last_name,
                                    },
                                    false
                                )}`
                        )
                        .join(", ")}`}
                >
                    <Button size="auto" variant="normal">
                        <Badge
                            type="info"
                            content={
                                <span className="flex items-center gap-x-1 text-[12px]">
                                    <UserIcon className="size-[12px] stroke-[--color-info-text]" />
                                    {`${
                                        loggedInUserIdIsInList ? `You and ` : ""
                                    } ${
                                        loggedInUserIdIsInList
                                            ? users.length - 1
                                            : users.length
                                    } user${
                                        loggedInUserIdIsInList &&
                                        users.length - 1 === 1
                                            ? ""
                                            : "s"
                                    }`}
                                </span>
                            }
                        />
                    </Button>
                </Tooltip>
            );
        }

        if (users.length === 1 && !loggedInUserIdIsInList) {
            return (
                <Badge
                    type="info"
                    content={
                        <span className="flex items-center gap-x-1 text-[12px]">
                            <UserIcon className="size-[12px] stroke-[--color-info-text]" />
                            {displayNameInRightFormat(
                                {
                                    firstName: users[0].first_name,
                                    lastName: users[0].last_name,
                                },
                                false
                            )}
                        </span>
                    }
                />
            );
        }

        if (users.length === 1 && loggedInUserIdIsInList) {
            return (
                <Badge
                    type="info"
                    content={
                        <span className="flex items-center gap-x-1 text-[12px]">
                            <UserIcon className="size-[12px] stroke-[--color-info-text]" />
                            You
                        </span>
                    }
                />
            );
        }
    }

    return "--";
};

export const userIsTasKViewer = (task?: ITask, userId?: string) => {
    if (!task || !userId) return false;
    if (task.creator.user_id === userId) return false;

    return Boolean(task?.viewers?.find((viewer) => viewer.user_id === userId));
};
